import CartStore from './CartStore';
import { ExternalCallbackStore, TranslationsStore, EnvironmentStore, PropStateStore } from '../../common';
import BillStore from './BillStore';
import LocationStore from './LocationStore';
import LogInStore from './LogInStore';
import MenuItemStore from './MenuItemStore';
import NavItemStore from './NavItemStore';
import NotificationStore from './NotificationStore';
import OverlayNoticeStore from './OverlayNoticeStore';
import ProfileTypeStore from './ProfileTypeStore';
import SearchStore from './SearchStore';
import SectionStore from './SectionStore';
import SsoStore from './SsoStore';
export class HeaderRootStore {
    constructor(props) {
        Object.defineProperty(this, "externalCallbackStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "environmentStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "propStateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "translationsStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "locationStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "menuItemStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cartStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "logInStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "overlayNoticeStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "searchStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "profileTypeStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "navItemStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "billStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "notificationStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sectionStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.environmentStore = new EnvironmentStore(this, props);
        this.propStateStore = new PropStateStore(props);
        this.externalCallbackStore = new ExternalCallbackStore(props);
        this.translationsStore = new TranslationsStore(this, props.translations);
        this.locationStore = new LocationStore(this, props);
        this.sectionStore = new SectionStore(this, props);
        this.ssoStore = new SsoStore(this, props);
        this.profileTypeStore = new ProfileTypeStore(this, props.profileTypes);
        this.menuItemStore = new MenuItemStore(this, props);
        this.cartStore = new CartStore(this, props);
        this.logInStore = new LogInStore(this);
        this.overlayNoticeStore = new OverlayNoticeStore(this, props.overlayNotice);
        this.searchStore = new SearchStore(this);
        this.billStore = new BillStore(this);
        this.navItemStore = new NavItemStore(this);
        this.notificationStore = new NotificationStore(this);
    }
}
export default HeaderRootStore;
//# sourceMappingURL=HeaderRootStore.js.map